import React from 'react'
import Navbar from './Navbar'
import '../css/strategy.css'
import StrtMain1 from './StrtMain1'
import KeyFeat from './KeyFeat'
import StrtMain2 from './StrtMain2'
import Footer from './Footer'
import { useLocation } from 'react-router-dom';
function useQuery() {
  return new URLSearchParams(useLocation().search);
}


function Strategy() {
  const query = useQuery();
  const selectedService = query.get('service');

  return (
    <div className='StrategyMain'>
        <Navbar page="serv"/>
        <StrtMain1 service={selectedService} />
        <KeyFeat service={selectedService} />
        <StrtMain2 service={selectedService} />
        <Footer/>
    </div>
  );
}

export default Strategy